module.exports = __webpack_public_path__ + "static/media/face.f4f510b6.png";